export const OnChangeAction = (paramParameters: any) => {
  return {
    type: 'onChange',
    paramParameters: paramParameters,
  }
}
